export enum ADJUSTMENTS {
  BRIGHTNESS = 'brightness',
  SATURATION = 'saturation',
  CONTRAST = 'contrast',
}

export interface IAdjustments {
  brightness: number;
  saturation: number;
  contrast: number;
}

